import * as React from "react";
import {
  Toolbar,
  Typography,
  Theme,
  makeStyles,
  createStyles,
  Hidden,
  IconButton,
  Divider,
  Box,
  useTheme,
  AppBar,
} from "@material-ui/core";
import UserMenu from "../UserMenu";
import { LocalCache } from "../../helpers/cache";
import IUserResponse from "../../core/contracts/IUserResponse";
import MenuIcon from "@material-ui/icons/Menu";
import { useHubx } from "../../HubX";
import { EVENT_OPEN_DRAWER } from "../../Events";
import APPLogo from "../../assets/icons/AppLogo";
import clsx from "clsx";
import WMLettersLogo from "../../assets/icons/WMLettersLogo";
import Notification from "../../features/Notification";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
    },

    menuWrapper: {
      "display": "flex",
      "flex": 1,
      "justifyContent": "space-between",
      "alignItems": "center",

      "& h1": {
        fontWeight: "bold",
      },
    },

    menuWrapper2: {
      display: "flex",
      flex: 1,
      justifyContent: "flex-end",
      alignItems: "center",
    },

    iconsWrapper: {
      "display": "flex",
      "alignItems": "center",

      "& .menu-icon": {
        flex: 1,
      },
    },

    appNameWrapper: {
      "columnGap": `${theme.spacing(2)}px`,
      "& svg": {
        width: "1.5em",
        height: "1.5em",
      },
    },

    mobileIcon: {
      "& svg": {
        width: "2em",
        height: "2em",
      },
    },

    mobileAppBar: {
      background: theme.palette.common.white,
    },
  })
);

function Header() {
  const classes = useStyles();
  const hub = useHubx();
  const theme = useTheme();

  const [userName, setUserName] = React.useState<string>("");

  React.useEffect(() => {
    const sessionCache = new LocalCache();
    const userData = sessionCache.get<IUserResponse>("user");
    if (userData) {
      setUserName(userData?.nome || "");
    }
  }, []);

  const handleClick = () => {
    hub.notify(EVENT_OPEN_DRAWER);
  };

  return (
    <>
      {/* Mobile */}
      <Hidden smUp>
        <AppBar className={classes.mobileAppBar}>
          <Toolbar>
            <div className={classes.iconsWrapper}>
              <IconButton className="menu-icon" onClick={handleClick}>
                <MenuIcon />
              </IconButton>
            </div>

            <div className={classes.menuWrapper}>
              <span className={classes.mobileIcon}>
                <WMLettersLogo viewBox="15 15 55 55" backgroundColor={theme.palette.primary.main} />
              </span>

              <div className={classes.menuWrapper2}>
                <Notification />

                <UserMenu name={userName} />
              </div>
            </div>
          </Toolbar>
        </AppBar>
      </Hidden>

      {/* Desktop */}
      <Hidden xsDown>
        <Toolbar className={classes.root}>
          <div className={classes.menuWrapper}>
            <div className={clsx(classes.iconsWrapper, classes.appNameWrapper)}>
              <Typography component="h1" variant="h3" color="textSecondary">
                Receitas Acessórias
              </Typography>
            </div>

            <div className={classes.menuWrapper2}>
              <UserMenu name={userName} />
            </div>
          </div>
        </Toolbar>

        <Box height={2} boxShadow={2} bgcolor="#626B6B">
          <Divider />
        </Box>
      </Hidden>
    </>
  );
}

export default Header;
